// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a3876b5b","580":"301eee66"}[chunkId] + ".chunk.js";
};